import { Controller } from "@hotwired/stimulus"

// Quando una lista viene deselezionata, i select "list_index" dei suoi to-do
// passano a "Senza lista" così l'utente VEDE che quei to-do non verranno
// importati, a meno che non scelga un'altra lista per ciascuno.
export default class extends Controller {
  static targets = ["listSelect"]

  toggleList(event) {
    const listKey = event.target.dataset.backlogReviewListParam
    if (event.target.checked) return
    // Azzera solo i select attualmente puntati su QUESTA lista (compresi quelli
    // riassegnati qui a mano), non quelli spostati altrove — così una scelta
    // deliberata dell'utente non viene sovrascritta.
    this.listSelectTargets
      .filter((select) => select.value === listKey)
      .forEach((select) => { select.value = "" })
  }
}
